import React, { useState } from "react";

const SuscripcionSection = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email) {
      setStatus("Por favor, ingresa un correo válido.");
      return;
    }

    // ✅ Aquí va tu URL del Google Apps Script desplegado como WebApp
    fetch("TU_URL_DE_GOOGLE_WEBAPP", {
      method: "POST",
      body: new URLSearchParams({ email }),
    })
      .then(() => {
        setStatus("¡Suscripción exitosa! Te añadimos al newsletter.");
        setEmail("");
      })
      .catch(() => setStatus("Ocurrió un error. Intenta de nuevo."));
  };

  return (
    <section
      className="py-12 bg-black text-white text-center"
      aria-label="Suscripción al newsletter de Seguridad y Salud en el Trabajo en Latinoamérica"
    >
      <div className="max-w-3xl mx-auto px-4">
        <div className="relative bg-gray-800 rounded-lg p-8 shadow-lg">
          {/* Imagen con SEO optimizado */}
          <div className="mb-6">
            <img
              src="https://celebratufiesta.com.co/wp-content/uploads/2025/01/LETRAS.png"
              alt="Newsletter de Seguridad y Salud en el Trabajo por Ernesto Mora"
              className="w-full h-auto rounded"
            />
          </div>

          {/* Título SEO */}
          <h2 className="text-3xl font-bold mb-4 text-[#FFD700]">
            Suscríbete al Newsletter de Seguridad y Salud en el Trabajo
          </h2>
          <p className="mb-6 text-gray-300">
            Recibe consejos prácticos sobre <strong>prevención de riesgos laborales</strong>,{" "}
            <strong>innovación en SST</strong> e <strong>inteligencia artificial aplicada</strong>,
            directamente en tu correo.
          </p>

          {/* Formulario */}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-semibold mb-1"
              >
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ejemplo@correo.com"
                className="w-full p-2 border border-gray-300 rounded bg-white text-black focus:outline-none focus:ring-2 focus:ring-yellow-500"
                required
              />
            </div>
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-[#FFD700] via-[#FFC700] to-[#FFB800] text-black font-bold py-2 px-4 rounded transition-shadow hover:from-[#FFC700] hover:via-[#FFB800] hover:to-[#FFA500] hover:shadow-lg"
            >
              SUSCRIBIRME A ERNESTO NEWSLETTER
            </button>
          </form>

          {/* Estado */}
          {status && (
            <p className="mt-4 text-sm text-gray-300" role="alert">
              {status}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default SuscripcionSection;
